// PluginContract_LineNumberedParagraphNode.ts
export const LineNumberedParagraphContract = {
  pluginName: 'LineNumberedParagraphPlugin',
  nodeTypes: ['LineNumberedParagraphNode'],
  register: (editor: any) => {
    editor.registerNodeType?.('LineNumberedParagraphNode');
    console.log('🔌 [LineNumberedParagraphPlugin] Registered LineNumberedParagraphNode');
  },
};